import PaymentRequest from '@/views/PaymentRequest.vue';

const paymentRequestRoutes = [
  {
    path: '/payment-request',
    name: 'payment-request',
    component: PaymentRequest,
    meta: {
      breadcrumb: [
        { name: 'Invoice Registry', link: '/home' },
        { name: 'Payment Request', link: '/payment-request' },
      ],
    },
  },
];

export default paymentRequestRoutes;
